export function lenisScroll() {
    if (!window.lenis && typeof Lenis !== 'undefined') {
        window.lenis = new Lenis({
        smooth: true,
        lerp: 0.1,
        });

        requestAnimationFrame(function raf(time) {
        window.lenis.raf(time);
        requestAnimationFrame(raf);
        });
    }
}